import { useContext, useEffect, useRef, useState } from "react";
import DOMPurify from "dompurify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBold, faCircleCheck, faClose, faImage, faItalic, faLink, faUnderline } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { useLocation } from "react-router-dom";

import { useGlobalMedic } from "../../services/global-medic/gobal-medic.context";
import { AuthenticationContext } from "../../services/authentication/authentication.context";
import { AppAlert } from "../utilities/alert";
import { Loader } from "../utilities/loader";
import { formatUrl } from "../../helpers/parse-url";



export const UpdateDiscussion = ({ tagsData, checkTag, checkedData }) => {

    const { editDiscussionData } = useGlobalMedic();

    const [formInput, setFormInput] = useState({
        title: '',
        content: '',
        tags: [],
        imageFile: null,
        oldImage: null
    });
    const [commandList, setCommandList] = useState([]);
    const [onAlert, setOnAlert] = useState();
    const [loading, setLoading] = useState(false);
    const [oldPostImage, setOlPostImage] = useState(null);

    const { token } = useContext(AuthenticationContext);

    const  post  = useLocation()?.state?.post;

    useEffect(() => {
        setFormInput((inpt) => ({
            ...inpt,
            title: post?.title,
            content: post?.content,
            tags: post?.tags
        }));
        setOlPostImage(post?.media?.image);
    },[post])


    const handleCheck = (id) => {
        checkTag(id);
        if (formInput.tags.includes(id)) {
            setFormInput((inpt) => ({ ...inpt, tags: inpt.tags.filter((v) => v !== id) }))
        } else {
            setFormInput((inpt) => ({ ...inpt, tags: [...inpt.tags, id] }));
        }
    }

    const isChecked = (id) => checkedData.includes(id);


    const titleRef = useRef();
    const bodyRef = useRef();
    const fileBtnRef = useRef();

    const { title, content } = formInput;

    const isNull = (v) => v === '' || v === undefined || v === null;

    const isInvalidData = isNull(title) || isNull(content) || content === '<br>';

    const isSelected = (key) => {
        return commandList.includes(key);
    }

    const toggleSelect = (key) => {
        if (commandList.includes(key)) {
            setCommandList((list) => list.filter((k) => k !== key));
            return;
        } else {
            setCommandList((list) => ([...list, key]));
        }
    }

    const handleFormSubmit = async () => {
        setLoading(true);
        if (isInvalidData) {
            setOnAlert({
                caption: 'Invalid input!',
                message: 'Please provide all the required data.',
                accept: 'Ok',
                onAccept: () => setOnAlert()
            });
            setLoading(false);
            return;
        }

        //console.log(formInput);
        const responseData = await editDiscussionData(formInput, post?._id, token);
        if (responseData?.error) {
            setOnAlert({
                caption: 'Error!',
                message: responseData?.error,
                accept: 'Ok',
                onAccept: () => setOnAlert()
            });
            setLoading(false);
            return;
        }

        setOnAlert({
            caption: 'Success!',
            message: responseData?.message,
            accept: 'Ok',
            onAccept: () => {
                setOnAlert();
                window.location.href = "/globalmedic"
            }
        });

        setLoading(false);
    }


    return (
        <form
            className="post-discussion-form"
            onSubmit={(e) => {
                e.preventDefault();
                handleFormSubmit();
            }}
        >
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    acceptAction={onAlert.onAccept}
                    rejectAction={onAlert.onReject}
                    close={() => setOnAlert()}
                />
            )}
            {loading && <Loader />}
            <div className="p-input-container">
                <label htmlFor="title" className="input-label">Title</label>
                <div
                    className="disc-input"
                    contentEditable
                    ref={titleRef}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
                    onBlur={() => setFormInput((v) => ({
                        ...v,
                        title: titleRef.current.innerText
                    }))}

                ></div>
            </div>
            <div className="format-bar">
                <>
                    <input
                        type="file"
                        className="file-btn-input"
                        onChange={(e) => {
                            setFormInput((v) => ({ ...v, imageFile: e.target.files[0] }))
                            if (post?.media?.image) {
                                /** set the present image's url to oldImage so it can be tracked
                                 * and deleted, if the image is replaced with a new one 
                                 */
                                setFormInput((v) => ({...v, oldImage: post?.media?.image }))
                            }
                        }}
                        ref={fileBtnRef}
                    />
                    <button
                        className="format-btn"
                        onClick={(e) => {
                            e.preventDefault();
                            fileBtnRef.current.click();
                        }}
                    >
                        <FontAwesomeIcon icon={faImage} />
                    </button>
                </>

                <button 
                    className="format-btn"
                    onClick={(o) => {
                        o.preventDefault();
                        let linkURL = prompt('Enter URL:','https://pathtourl')
                        document.execCommand('createLink',true, linkURL )
                    }}
                >
                    <FontAwesomeIcon icon={faLink} />
                </button>
                <button
                    className={classNames("format-btn", { 'selected': isSelected('bold') })}
                    onClick={(e) => {
                        e.preventDefault();
                        document.execCommand('bold')
                    }}

                >
                    <FontAwesomeIcon icon={faBold} />
                </button>
                <button 
                    className="format-btn"
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                >
                    <FontAwesomeIcon icon={faItalic} />
                </button>
                <button 
                    className="format-btn"
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                >
                    <FontAwesomeIcon icon={faUnderline} />
                </button>
            </div>
            <div className="p-input-container lg-input">
                <label htmlFor="title" className="input-label">Content</label>
                <div
                    className="disc-input"
                    contentEditable
                    ref={bodyRef}
                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
                    onBlur={() => {
                        setFormInput((v) => ({
                            ...v,
                            content: bodyRef.current.innerHTML
                        }));

                    }}
                ></div>
            </div>

            {(formInput?.imageFile || oldPostImage) && (
                <div className="disc-img-box">
                    <button
                        className="close-img"
                        onClick={(e) => {
                            e.preventDefault();
                            setFormInput((v) => ({ ...v, imageFile: null }))
                            setOlPostImage(null);
                            setFormInput((v) => ({...v, oldImage: post?.media?.image}))
                        }}
                    >
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                    <img
                        src={
                            formInput.imageFile ? 
                            URL.createObjectURL(formInput?.imageFile) :
                            formatUrl(oldPostImage)
                        }
                        width={200}
                        height={200}
                        alt=""
                    />
                </div>
            )}

            <div className="tags-container">
                {tagsData.map((tag, id) => (
                    <button
                        className="tag-button"
                        key={id}
                        onClick={(e) => {
                            e.preventDefault();
                            handleCheck(tag);
                        }}
                    >
                        {isChecked(tag) && <FontAwesomeIcon icon={faCircleCheck} className="tag-chk" />}
                        <span className="tag-nm">{tag}</span>
                    </button>
                ))}
            </div>
            <button
                className={classNames("disc-frm-bttn", { 'active-button': !isInvalidData })}
                disabled={isInvalidData}

            >
                Submit
            </button>

        </form>
    )
}